<template>
  <svg
    width="23px"
    height="16px"
    viewBox="0 0 23 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    @click="$emit('iconClicked')"
  >
    <!-- Generator: Sketch 60.1 (88133) - https://sketch.com -->
    <title>icon/arrow/right</title>
    <desc>Created with Sketch.</desc>
    <g
      id="UX-HF"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Table-number---keyboard-displays-when-field-is-selected"
        transform="translate(-230.000000, -210.000000)"
      >
        <g id="icon/arrow/right" transform="translate(228.000000, 206.000000)">
          <g
            id="Group"
            transform="translate(12.500000, 12.000000) rotate(-180.000000) translate(-12.500000, -12.000000) translate(2.000000, 5.000000)"
          >
            <rect
              id="Rectangle-5"
              :fill="color"
              transform="translate(11.000000, 7.000000) scale(-1, 1) translate(-11.000000, -7.000000) "
              x="1"
              y="6"
              width="20"
              height="2"
            />
            <polyline
              id="Stroke-3"
              :stroke="color"
              stroke-width="2"
              points="8 14 0 7 8 0"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: '',
    },
  },
}
</script>
